import {addComponentKeysets} from '../../../i18n';

import en from './en.json';
import ru from './ru.json';

const COMPONENT = 'Accordion';

export default addComponentKeysets({en, ru}, COMPONENT);
